<template>
    <div class="modal fade " id="purchaseOrderExtraChargeModal">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info">
                    <h5 class="modal-title">Extra Charges</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{errorMessage}}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <form>

                        <div class="form-group">
                            <label for="cost_type">Charge name</label>
                            <input type="text" class="form-control" placeholder="" v-model="chargeData.cost_type" id="cost_type">
                        </div>
                        <div class="form-group">
                            <label for="quantity">Amount</label>
                            <input type="text" class="form-control" placeholder="" v-model="chargeData.quantity" id="quantity">
                        </div>
                        <div class="form-group">
                            <label for="amount">Cost</label>
                            <input type="text" class="form-control" placeholder="" v-model="chargeData.amount" id="amount">
                        </div>

                        <div  class="mt-3 text-right">
                            <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary close-modal" v-on:click="save" :class="{'disabled': this.loading}">Save</button>
                        </div>
                    </form>

                </div>



            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "PurchaseOrderExtraChargeModal",
    props: ['order', 'sub_total_cost', 'charge', 'bus'],
    created() {
        if(this.charge) {
            this.chargeData = _.cloneDeep(this.charge);
        }
    },
    beforeMount() {
        if(this.charge) {
            this.chargeData = _.cloneDeep(this.charge);
        }
    },
    mounted() {
        if(this.charge) {
            this.chargeData = _.cloneDeep(this.charge);
        }
        this.bus.$on('setChargeData', (charge) => {
            this.chargeData = _.cloneDeep(charge);
        });
        //console.log(this.chargeData)
    },
    data() {
        return {
            submitted: false,
            chargeData: {
                id: null,
                purchase_order_id: null,
                cost_type: null,
                amount: 0.00,
                quantity: 0,
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        save() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('po.charge.store', {id: this.order.id});

            if(this.chargeData.id) {
                apiUrl = window.route('po.charge.update', {id: this.order.id, extra_charge_id: this.chargeData.id});
            }
            return axios.post(apiUrl, this.chargeData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if(data.data) {
                        self.setSuccessMessage(data.message);
                        // this.chargeData = data.data;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('extraChargeUpdated', {oldData: this.chargeData, newData: data.data});
                        this.chargeData = {
                            id: null,
                            purchase_order_id: null,
                            cost_type: null,
                            amount: 0.00,
                            quantity: 0,
                        };
                        $('#purchaseOrderExtraChargeModal').modal('hide');
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
